<template>
  	<div class="welcome">
		<v-card
		class="mx-auto centrelize"
		max-width="450"
		outlined
		>
			<v-card-title>
				{{ $t("welcome.card.title") }}
			</v-card-title>

			<v-divider></v-divider>

			<v-card-text>
				{{ $t("welcome.card.text") }}
			</v-card-text>
			<center><v-btn :to="`/${$i18n.locale}/register`" elevation="10" color="primary">>> {{ $t("welcome.card.signupnow") }} <<</v-btn></center>
			<br>

			<v-divider></v-divider>
			<v-card-actions>
			  <v-btn :to="`/${$i18n.locale}/login`" small color="m-right primary">{{ $t("welcome.card.login") }}</v-btn>
			  <v-divider vertical></v-divider>
			  <span class="p-left">{{ $t("welcome.card.guest?") }}</span>
			  <v-btn outlined :to="`/${$i18n.locale}/register`" small  color="primary">{{ $t("welcome.card.signup") }}</v-btn>
				
			</v-card-actions>
		</v-card>
	</div>
</template>
<style scoped>
	.p-left{
		padding-left: 8px;
		padding-right: 8px;
		color: grey;
		font-size: 14px;
	}
	.m-right{
		margin-right: 8px;
	}
	.centrelize {
		/*position: absolute;
	    top: 50%;
	    left: 50%;
	    transform: translate(-50%, -50%);*/
	     /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
	    margin: 0 auto; /* Added */
        float: none; /* Added */
        margin-bottom: 10px; /* Added */

	}
</style>
<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Welcome',
  components: {
    //HelloWorld
  }
};
</script>
